import React, { useState } from 'react';
import { decorAPI } from '../../utils/api';

export default function DecorBooking() {
  const [form, setForm] = useState({
    client_name: '',
    phone: '',
    email: '',
    wedding_date: '',
    venue: '',
    package: 'royal_floral',
    special_notes: ''
  });

  const [msg, setMsg] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (field) => (e) => {
    setForm((prev) => ({ ...prev, [field]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMsg(null);
    try {
      const res = await decorAPI.submitBooking(form);
      setMsg({ ok: true, text: `${res.message || 'Decor Booking Submitted!'} Reference Code: ${res.booking_ref}` });
      setForm({
        client_name: '', phone: '', email: '', wedding_date: '',
        venue: '', package: 'royal_floral', special_notes: ''
      });
    } catch {
      setMsg({ ok: false, text: 'Could not submit booking. Please contact Krishna Khanal directly at 9867155395.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="sec-wrapper" style={{ maxWidth: '960px' }}>
      {/* Unified Vivah Nepal Hero Banner */}
      <section className="hero-section">
        <div className="hero-content">
          <div style={{ marginBottom: '1.2rem' }}>
            <span className="badge-hero-top">
              ✦ SABITRI MANDAP DECOR & EVENT RESERVATIONS ✦
            </span>
          </div>

          <h1 className="hero-title">
            Book Mandap Decor & Tent House for <span className="hero-title-gradient">Your Wedding Day</span>
          </h1>

          <p className="hero-subtitle">
            Managed by <strong>Krishna Khanal (9867155395)</strong> & <strong>Laxmikant Timilsina (9857074103)</strong>. Corporate Office: <strong>Yogikuti Chowk, Butwal-10, Nepal</strong>.
          </p>
        </div>
      </section>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(310px, 1fr))', gap: '2rem' }}>
        {/* Booking Form Card */}
        <div className="card" style={{ border: '1.5px solid #D4AF37' }}>
          <h3 style={{ fontSize: '1.4rem', fontWeight: 700, color: '#9E1B32', marginBottom: '1rem', fontFamily: 'var(--serif)', borderBottom: '1px solid #E8DFD1', paddingBottom: '0.6rem' }}>
            📅 Mandap & Decor Booking Form
          </h3>

          {msg && (
            <div style={{
              background: msg.ok ? '#e8f5e9' : '#FEECEC',
              color: msg.ok ? '#2e7d32' : '#9E1B32',
              border: msg.ok ? '1px solid #a5d6a7' : '1px solid rgba(158,27,50,0.3)',
              borderRadius: '14px', padding: '1rem 1.2rem', marginBottom: '1.5rem',
              fontSize: '0.88rem', fontWeight: 700
            }}>
              {msg.ok ? '✓ ' : '⚠️ '}{msg.text}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '1.2rem', marginBottom: '1.4rem' }}>
              <div>
                <label style={{ display: 'block', fontSize: '0.78rem', fontWeight: 700, color: '#1C1014', marginBottom: '0.4rem', textTransform: 'uppercase' }}>Client Name *</label>
                <input type="text" className="form-input" value={form.client_name} onChange={handleChange('client_name')} placeholder="Your full name" required />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '0.78rem', fontWeight: 700, color: '#1C1014', marginBottom: '0.4rem', textTransform: 'uppercase' }}>Phone Number *</label>
                <input type="tel" className="form-input" value={form.phone} onChange={handleChange('phone')} placeholder="98XXXXXXXX" required />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '0.78rem', fontWeight: 700, color: '#1C1014', marginBottom: '0.4rem', textTransform: 'uppercase' }}>Wedding Date *</label>
                <input type="date" className="form-input" value={form.wedding_date} onChange={handleChange('wedding_date')} required />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '0.78rem', fontWeight: 700, color: '#1C1014', marginBottom: '0.4rem', textTransform: 'uppercase' }}>Venue Location *</label>
                <input type="text" className="form-input" value={form.venue} onChange={handleChange('venue')} placeholder="Venue name or address" required />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '0.78rem', fontWeight: 700, color: '#1C1014', marginBottom: '0.4rem', textTransform: 'uppercase' }}>Select Decor Package</label>
                <select className="form-input" value={form.package} onChange={handleChange('package')}>
                  <option value="royal_floral">Royal Palpali Floral Mandap</option>
                  <option value="fairy_lights">Fairy Light & Marquee Canopy</option>
                  <option value="grand_mandap">Yogikuti Grand Stage Backdrop</option>
                  <option value="custom">Custom Mandap Setup</option>
                </select>
              </div>
            </div>

            <div style={{ marginBottom: '1.5rem' }}>
              <label style={{ display: 'block', fontSize: '0.78rem', fontWeight: 700, color: '#1C1014', marginBottom: '0.4rem', textTransform: 'uppercase' }}>Special Requirements & Notes</label>
              <textarea className="form-input" rows={3} value={form.special_notes} onChange={handleChange('special_notes')} placeholder="Flower preferences, stage throne demands, lighting requirements..." />
            </div>

            <button className="btn btn-primary btn-full" type="submit" disabled={loading} style={{ padding: '0.85rem' }}>
              {loading ? '⏳ Confirming Booking…' : 'Confirm Mandap Decor Reservation →'}
            </button>
          </form>
        </div>

        {/* Deposit & Info Side Card */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
          <div className="card" style={{ background: 'linear-gradient(135deg, #1C1014 0%, #28171C 100%)', color: 'white', border: '1.5px solid #D4AF37', textAlign: 'center' }}>
            <span className="badge" style={{ background: 'rgba(212, 175, 55, 0.25)', color: '#F7D070', marginBottom: '0.8rem' }}>
              💳 eSewa / Fonepay Booking Deposit
            </span>
            <h4 style={{ fontFamily: 'var(--serif)', fontSize: '1.5rem', color: '#F7D070', marginBottom: '0.6rem' }}>
              Confirming Event Date
            </h4>
            <p style={{ fontSize: '0.84rem', color: 'rgba(255,255,255,0.85)', lineHeight: 1.6, marginBottom: '1.2rem' }}>
              A 30% deposit confirms your event date. Send payment receipt screenshot to manager <strong>Krishna Khanal (9867155395)</strong> or <strong>Laxmikant Timilsina (9857074103)</strong>.
            </p>
            <div style={{ background: '#0F090B', padding: '1rem', borderRadius: '14px', border: '1px solid rgba(247,208,112,0.3)', marginBottom: '1.2rem' }}>
              <div style={{ fontSize: '0.72rem', textTransform: 'uppercase', color: 'rgba(255,255,255,0.6)', letterSpacing: '0.05em' }}>DECOR DIRECTOR LINE</div>
              <div style={{ fontSize: '1.2rem', fontWeight: 900, color: '#F7D070', margin: '0.2rem 0' }}>9867155395 (Krishna Khanal)</div>
              <div style={{ fontSize: '0.78rem', color: 'rgba(255,255,255,0.8)' }}>Sabitri Decor & Tent House</div>
            </div>
            <a href="tel:9867155395" className="btn btn-secondary btn-full">
              📞 Call Krishna: 9867155395 →
            </a>
          </div>

          <div className="card" style={{ border: '1px solid #E8DFD1', background: '#FAF6ED' }}>
            <h4 style={{ fontWeight: 800, color: '#9E1B32', marginBottom: '0.6rem' }}>🌸 Why Book Decor Early?</h4>
            <ul style={{ listStyle: 'none', fontSize: '0.84rem', color: '#6E615E', lineHeight: 1.8 }}>
              <li>✓ Popular wedding auspicious dates book fast</li>
              <li>✓ Time for floral sourcing & stage drafting</li>
              <li>✓ Price guarantee on marquee tent packages</li>
              <li>✓ Guaranteed setup team & equipment</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}